module.exports = __webpack_public_path__ + "55d69488f9f064ee4b9323fbc02cd192.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KZ.svg
// module id = fI0B
// module chunks = 0